module.exports = __webpack_public_path__ + "img/photozone-3.1307af1d.webp";